import React from 'react';

const Shipping = () => {
    return (
        <div>
            <h2>Shipping</h2>
        </div>
    );
};

export default Shipping;